import { useRef } from 'react';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';


const ServicesDeadline = ({list, title}) => {
  const sectionRef = useRef(null);
  const titleRef = useRef(null)
  const containerRef = useRef(null)

  const items = [
    {
      title: 'Для пространств до 700 м²:',
      listItems: [
        'архитектурный анализ — 7 дней',
        'разработка концепции — 20 дней',
        'подготовка рабочей документации — 20 дней',
      ],
    },
    {
      title: 'Для пространств от 1,500 до 2,500 м²:',
      listItems: [
        'архитектурный анализ — 10 дней',
        'разработка концепции — 20 дней',
        'подготовка рабочей документации — 33 дня',
      ],
    },
    {
      title: 'Для пространств свыше 5,500 м²:',
      listItems: ['сроки определяются индивидуально'],
    },
  ];

  useGSAP(() => {
    const mm = gsap.matchMedia();

    mm.add('(min-width: 1280px)', () => {

              gsap.fromTo(containerRef.current, {
                y: '13rem'
              },
                  {
                y: 0,
                ease: "none",
                scrollTrigger: {
                  trigger: sectionRef.current,
                  start: "top bottom", 
                  end: "top 60%",  
                  scrub: 0.1,  
                },
              });


      const ctx = gsap.context(() => {

        gsap.fromTo(titleRef.current, { opacity: 0 }, {
          opacity: 1,
  
          duration: 1,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 80%",
          },
        });


        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 70%',
            end: 'bottom 20%',
            toggleActions: 'play none none reverse',
          },
        });

        tl.from('.deadline-item h3', {
          x: -50,
          opacity: 0,
          duration: 0.6,
          stagger: 0.2,
          ease: 'power2.out',
        });

        tl.from(
          '.deadline-item .list-block p',
          {
            y: 30,
            opacity: 0,
            duration: 0.4,
            stagger: 0.1,
            ease: 'power2.out',
          },
          '<+=0.15' 
        );

    
        tl.from('.deadline-item .divider-line', {
          opacity: 0,
          duration: 0.6,
          stagger: 0.1,
          ease: 'power1.out',
        });
      }, sectionRef);

      return () => ctx.revert();
    });

    return () => mm.revert();
  }, {scope: sectionRef});

  return (
    <section
      ref={sectionRef}
      className="py-[4rem] container-max flex-col md:py-[5rem] lg:py-[6rem] xl:py-[8rem] w-full container-padding relative"
    >
      <div className='' ref={containerRef}>

        <div className="flex items-center justify-center md:text-center mb-[4rem] lg:mb-[6rem]">
          <h2 ref={titleRef} className="heading-3 lg:max-w-[83rem] xl:max-w-[106rem] [&>.selected]:italic [&>.selected]:text-dusty-green-dark" dangerouslySetInnerHTML={{__html: title}}/>
        </div>

        <div className="flex flex-col gap-[2.4rem]">
          {list.map((item, index) => (
            <div
              key={index}
              className={`deadline-item relative md:gap-[8.5%] md:flex w-full md:justify-between pb-[2.4rem] md:border-none  ${
        index !== items.length - 1
          ? 'border-b-[1px] border-dark-blue-20'
          : ''
      }`}
            >
              <h3 className="heading-4 md:w-[50%] md:text-right mb-[1.2rem]">{item.title}</h3>

              <div className="divider-line w-[4.5%] absolute h-[1px] bg-dark-blue-20 hidden md:block top-[1rem] left-1/2 -translate-x-1/2"></div>

              <div className="list-block flex md:w-[50%] flex-col gap-[0.4rem]">
                {item.list.map((listItem, i) => (
                  <p key={'list' + i} className="text-1">
                    {listItem.text}
                  </p>
                ))}
              </div>
            </div>
          ))}
        </div>
              
      </div>
    </section>
  );
};

export default ServicesDeadline;
